import React from 'react';
import PostIdEdit from '@_jupiter_src/pages/[scope]/post/[postId]/edit.tsx';
import PostIdLayout from '@_jupiter_src/pages/[scope]/post/[postId]/_layout.tsx';
const post_id_layout_post_id_edit = props => (<PostIdLayout Component={PostIdEdit} {...props}></PostIdLayout>);
post_id_layout_post_id_edit.__isWrappedByLayout__ = true;
      
export default post_id_layout_post_id_edit;